<img onerror="this.src='assets/images/user.jpeg'" [src]="src | userImage" [alt]="alt" />
